import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { svgPaths } from '~/assets'
import signature from '~/assets/img/thematic-draw_pascoa_2026/signature.webp'

import { Loading, MultipleChoiceDraw } from '~/components'
import { Flex, Typography } from '~/ds-components'

import { GetPrizeStocksInterface } from '~/models/interfaces/services'
import { Services } from '~/services'

import { MultipleChoiceDrawBackground } from './styles'

const campaignContents = {
  default: { backgroundImage: svgPaths.defaultBackground },
}

interface PrizeStocksState {
  isLoading: boolean
  data?: GetPrizeStocksInterface
}

const getMaxRafflePrize = (data?: GetPrizeStocksInterface) => {
  if (!data?.rafflePrize.length) return { description: 'R$ 0,00' }

  return data.rafflePrize.reduce((max, curr) => {
    const currentValue = Number(curr.description.replace(/\D/g, ''))
    const maxValue = Number(max.description.replace(/\D/g, ''))
    return currentValue > maxValue ? curr : max
  }, data.rafflePrize[0])
}

const fetchPrizeStocks = async (
  contractNumber: string,
  slug: string,
  setPrizeStocksState: (state: PrizeStocksState) => void,
) => {
  setPrizeStocksState({ isLoading: true })

  try {
    const { data } = await Services.getPrizeStocks(contractNumber, slug)
    setPrizeStocksState({ isLoading: false, data })
  } catch {
    setPrizeStocksState({ isLoading: false })
  }
}

export const MultipleChoicePage = () => {
  const { slug = '', contractNumber = '' } = useParams<{ slug: string; contractNumber: string }>()

  const [prizeStocksState, setPrizeStocksState] = useState<PrizeStocksState>({
    isLoading: true,
  })

  useEffect(() => {
    if (!slug || !contractNumber) return
    fetchPrizeStocks(contractNumber, slug, setPrizeStocksState)
  }, [contractNumber, slug])

  const awardedPrize =
    prizeStocksState.data?.rafflePrize.find((prize) => prize.isAwarded)?.description || 'R$ 0,00'

  const maxPrize = getMaxRafflePrize(prizeStocksState.data)

  return (
    <MultipleChoiceDrawBackground backgroundImage={campaignContents.default.backgroundImage}>
      {prizeStocksState.isLoading ? (
        <Loading />
      ) : (
        <Flex
          alignItems="center"
          flexDirection={{ xs: 'column', lg: 'row' }}
          gap={40}
          justifyContent="center"
          width={{ xs: '100%', md: '80%', xl: '70%' }}
        >
          <header>
            <img src={signature} alt={prizeStocksState.data?.title || 'Campanha VIACERTA'} />

            <Typography
              as="p"
              color="grey.white"
              fontWeight={300}
              textAlign="center"
              textTransform="uppercase"
              variant="xLarge"
            >
              <Typography
                as="span"
                display="inline-block"
                fontStyle={'italic'}
                fontWeight={600}
                variant="xLarge"
              >
                Escolha
              </Typography>{' '}
              um ovo e{' '}
              <Typography
                as="span"
                display="inline-block"
                fontStyle={'italic'}
                fontWeight={600}
                variant="xLarge"
              >
                ganhe
              </Typography>{' '}
              até{' '}
              <Typography as="span" display="inline-block" fontWeight={800} variant="xLarge">
                {maxPrize.description}
              </Typography>
            </Typography>
          </header>

          <MultipleChoiceDraw value={awardedPrize} contractNumber={contractNumber} slug={slug} />
        </Flex>
      )}
    </MultipleChoiceDrawBackground>
  )
}
